/* eslint-disable complexity */
import React from 'react';
import { Box, Text } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import pdpCompareUtils from 'utils/pdpCompare';
import { getText } from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/compareItemLocale';
import { styles } from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/compareItemStyles';

export const renderAttributeCell = ({ sku, index, attribute, attrIndex }) => {
    if (!attribute || !sku) {
        return { cell: null, isCellEmpty: true };
    }

    let refinementName;
    let refinementValues;

    if (typeof attribute === 'string') {
        const skuFacet = sku?.facets?.find(facet => facet.name === attribute);
        const masterListRefinement = skuFacet?.values?.length ? pdpCompareUtils.findRefinementInMasterList(skuFacet.name) : null;

        if (masterListRefinement) {
            refinementName = masterListRefinement.value || null;
            const mappedValues = pdpCompareUtils.mapFacetValues(skuFacet.values, masterListRefinement);
            refinementValues = mappedValues.length > 0 ? mappedValues : ['-'];
        } else {
            refinementValues = ['-'];
        }
    }

    if (attribute && typeof attribute === 'object' && attribute !== null && !Array.isArray(attribute)) {
        const attributeKey = Object.keys(attribute)[0];
        const attributeValues = Object.values(attribute)[0];

        if (Array.isArray(attributeValues) && attributeValues.length > 0) {
            const facetMap = new Map(sku?.facets?.map(f => [f.name, f]) || []);
            refinementValues = [];

            const directFacet = facetMap.get(attributeKey);

            if (directFacet?.values?.length > 0) {
                const masterListRefinement = pdpCompareUtils.findRefinementInMasterList(directFacet.name);

                if (masterListRefinement) {
                    const values = pdpCompareUtils.mapFacetValues(directFacet.values, masterListRefinement);

                    if (values.length > 0) {
                        refinementValues.push(...values);
                    }
                }
            } else {
                attributeValues.forEach(attValue => {
                    const skuFacet = facetMap.get(attValue);

                    if (skuFacet?.values?.length > 0) {
                        const masterListRefinement = pdpCompareUtils.findRefinementInMasterList(skuFacet.name);

                        if (masterListRefinement) {
                            const values = pdpCompareUtils.mapFacetValues(skuFacet.values, masterListRefinement);

                            if (values.length > 0) {
                                refinementValues.push(...values);
                            }
                        }
                    }
                });
            }

            if (refinementValues.length > 0) {
                refinementName = getText(attributeKey) || attributeKey;
                const refinementValuesText = refinementValues.join(', ');

                if (attributeKey === 'targetedConcerns') {
                    refinementValues = [refinementValuesText];
                } else {
                    const refinementText =
                        attributeValues.includes('hairType') && attributeValues.includes('hairTexture')
                            ? getText('hairValues')
                            : getText('skinValues');
                    refinementValues = localeUtils.isFrench()
                        ? [`${refinementText} ${refinementValuesText}`]
                        : [`${refinementValuesText} ${refinementText}`];
                }
            } else {
                refinementValues = ['-'];
            }
        }
    }

    if (!refinementValues?.length) {
        return { cell: null, isCellEmpty: true };
    }

    const showDash = refinementValues.length === 1 && refinementValues[0] === '-';

    const cell = (
        <Box
            key={`attr-${attrIndex}-${index}`}
            backgroundColor={index === 0 && 'nearWhite'}
            borderLeftWidth={index > 0 && 1}
            borderColor={index > 0 && 'divider'}
            borderTopWidth={1}
            borderTopColor='divider'
            paddingLeft={4}
            paddingRight={4}
        >
            <div
                css={{
                    ...styles.cell,
                    ...(showDash
                        ? {
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%'
                        }
                        : {})
                }}
            >
                {showDash ? (
                    <Text aria-label='Not applicable'>-</Text>
                ) : (
                    <div>
                        {refinementName && <Text fontWeight='bold'>{refinementName}: </Text>}
                        <Text>{refinementValues.join(', ')}</Text>
                    </div>
                )}
            </div>
        </Box>
    );

    return { cell, isCellEmpty: showDash };
};
